const GET_FOOTER_URL = '/get-footer-data';

module.exports = {

    getFooter: function getFooter(company_id) {
        return window.axios.get(GET_FOOTER_URL, { params:
                {
                    company_id: company_id,
                }
        });
    }
};
